module.exports = __webpack_public_path__ + "img/joyskit-sm.a6989252.webp";